/**
 * @fileoverview Supply a consistent page identity and action placement across workspaces. The caller owns title meaning and action behavior; this component only composes their presentation. The embedded variant supports existing workspace shells without introducing another navigation or data boundary.
 */

import React from 'react';
import './AppPageHeader.css';
import AppIcon from "./AppIcon";



function AppPageHeader({ eyebrow, title, icon, actions, embedded = false }) {
  const header =
  <div className={`app-page-header${embedded ? ' app-page-header--embedded' : ''}`}>
                <div className="app-page-header__layout">
                    <div className="app-page-header__main">
                        {icon &&
        <div className="app-page-header__icon" aria-hidden="true">
                                <AppIcon icon={icon} />
                            </div>}

                        <div className="app-page-header__copy">
                            {eyebrow && <div className="app-page-header__eyebrow">{eyebrow}</div>}
                            <h1 className="app-page-header__title">{title}</h1>
                        </div>
                    </div>
                    {actions ? <div className="app-page-header__actions">{actions}</div> : null}
                </div>
        </div>;


  if (embedded) {
    return header;
  }

  return (
    <div className="app-page-header-shell">
            {header}
        </div>);

}

export default AppPageHeader;
